export const ultimaActualizacion = '04/11/2026 09:12';
